"use client";

import { useEffect, useState } from "react";

export function CurrentTimeIndicator({
  openHour,
  dayLength,
}: {
  openHour: number | null;
  dayLength: number;
}) {
  const [position, setPosition] = useState<number>(0);
  const [blockHeight, setBlockHeight] = useState<number>(48);

  useEffect(() => {
    // Set correct block height based on screen size
    const handleResize = () => {
      setBlockHeight(window.innerWidth < 600 ? 32 : 48);
    };

    // Set initial block height
    handleResize();

    // Add resize listener
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const calculatePosition = () => {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const openingHour = openHour || 0;

      // Calculate current time in decimal hours (e.g., 14:30 = 14.5)
      const currentTimeDecimal = currentHour + currentMinute / 60;

      // Calculate where we are in the day relative to opening hour
      const timeFromOpening = currentTimeDecimal - openingHour;

      // Convert to percentage of the visible calendar
      const percentage = timeFromOpening / dayLength;

      return percentage * dayLength * 2 * blockHeight;
    };

    // Set initial position
    setPosition(calculatePosition());

    // Update position every minute
    const interval = setInterval(() => {
      setPosition(calculatePosition());
    }, 60000);

    return () => clearInterval(interval);
  }, [openHour, dayLength, blockHeight]);

  if (position <= 0) return null;

  return (
    <>
      <div
        className="absolute left-0 right-0 z-10 pointer-events-none opacity-75 bg-blue-100"
        style={{
          top: `calc(${position}px + var(--title-height))`,
          height: "2px",
          transform: "translateY(-1px)",
        }}
      >
        <div
          className="absolute left-0 w-2 h-2 rounded-full bg-blue-100"
          style={{ transform: "translateY(-50%)", top: "50%" }}
        />
      </div>
    </>
  );
}
